import { toWWWLink } from '@core/external-links/models';

import type { ApiInstructor } from './apiTypes';
import type { Instructor } from './models/Instructor';

export const toInstructor = (apiInstructor: ApiInstructor): Instructor => ({
  aboutImageUrl: apiInstructor.aboutImageUrl,
  darkAboutImageUrl: apiInstructor.jumbotronUrlDark,
  id: apiInstructor.id,
  imageUrl: apiInstructor.imageUrl,
  isVisible: apiInstructor.isVisible,
  linkUrl: toLinkUrl(apiInstructor.username),
  name: apiInstructor.name,
  username: apiInstructor.username,
});

export const toLinkUrl = (username: string) => {
  return toWWWLink(`/instructors/${username}`);
};
